import React, { memo, useCallback, useMemo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import longestLabel from 'Pods/SearchPage/Shared/longestLabel'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearLicenses } from 'Pods/SearchPage/Store/actions/licenses'
import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

// Dropdown order; each license has a no-AI twin the store swaps in while AI usage is not allowed.
const LICENSE_LABEL_KEYS = [
  { values: [LICENSE_TYPE.ROYALTY_FREE, LICENSE_TYPE.ROYALTY_FREE_NO_AI], labelKey: 'royalty_free' },
  { values: [LICENSE_TYPE.EDITORIAL, LICENSE_TYPE.EDITORIAL_NO_AI], labelKey: 'editorial_short' },
  { values: [LICENSE_TYPE.CUSTOM, LICENSE_TYPE.CUSTOM_NO_AI], labelKey: 'custom' },
]

function License() {
  const translate = useTranslate()

  const licenses = useSearchPageStore(state => state.licenses)
  const aiUsageAllowed = useSearchPageStore(state => state.aiUsageAllowed)

  const reservedValue = useMemo(() => longestLabel(
    [...LICENSE_LABEL_KEYS.map(option => option.labelKey), 'ai_usage_allowed']
      .map(labelKey => translate(`search_page.filters.license.${labelKey}`)),
  ), [translate])

  const selectedValues = useMemo(() => {
    const values = LICENSE_LABEL_KEYS
      .filter(option => option.values.some(value => licenses.includes(value)))
      .map(option => translate(`search_page.filters.license.${option.labelKey}`))

    if (aiUsageAllowed) {
      values.push(translate('search_page.filters.license.ai_usage_allowed'))
    }

    return values
  }, [licenses, aiUsageAllowed, translate])
  const hasSelectedAnyFilter = selectedValues.length > 0

  const handleReset = useCallback(() => {
    clearLicenses()
  }, [])

  const content = useMemo(() => (
    <>
      <LicenseContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter, translate])

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={translate('search_page.filters.license.title')}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      selectedValues={selectedValues}
      reservedValue={reservedValue}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(License)
